import { render, staticRenderFns } from "./MapLegend.vue?vue&type=template&id=1b0a4e4f"
import script from "./MapLegend.vue?vue&type=script&lang=js"
export * from "./MapLegend.vue?vue&type=script&lang=js"
import style0 from "./MapLegend.vue?vue&type=style&index=0&id=1b0a4e4f&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.servis.leaseplan.cz/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b0a4e4f')) {
      api.createRecord('1b0a4e4f', component.options)
    } else {
      api.reload('1b0a4e4f', component.options)
    }
    module.hot.accept("./MapLegend.vue?vue&type=template&id=1b0a4e4f", function () {
      api.rerender('1b0a4e4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/services/MapLegend.vue"
export default component.exports